import React, { Component } from "react";
import "./App.css";
import firebase from "firebase";
import Logo from "./images/logo.png";
import request from "request";


class Admin extends Component {
  state = {
    isLoading: false,
  };

  componentDidMount = () => {
    console.log("hell")
    let isAdmin = localStorage.getItem("istrackingadmin");
    if (!isAdmin) {
      let pass = prompt("Enter Admin Password");
      if (pass === "test123") {
        localStorage.setItem("istrackingadmin", true);
      } else {
        alert("Wrong password");
        window.location.replace("/");
      }
    }

  }
  

  addItem = async () => {
    this.setState({isLoading: true});
    let phonenumber = document.getElementById("phonenumber").value;
    let agrecator = document.getElementById("agrecator").value;
    let awbnumber = document.getElementById("awbnumber").value;
    if (phonenumber.length !== 10) {
      alert("Incorrect Phone Number");
    } else if (awbnumber.length === 0) {
      alert("Please enter awb number");
    } else {
      this.setState({ isLoading: true });
      const d = new Date();
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let date = d.getDate();
      let orderMonth = months[d.getMonth()];

      //Generating Tracking Link
      let trackingLink;
      if (agrecator === "Shypway") {
        trackingLink = "https://homebakersmart.shipway.com/t/" + awbnumber;
      } else if (agrecator === "Nimbus Post") {
        trackingLink = "https://ship.nimbuspost.com/shipping/tracking/" + awbnumber;
      } else if (agrecator === "Delhivery(Direct)") {
        trackingLink = "https://www.delhivery.com/track/package/" + awbnumber;  
      } else if (agrecator === "Shiprocket") {
        trackingLink = "https://shiprocket.co/tracking/" + awbnumber;  
      } else if (agrecator === "Amazon Shipping") {
        trackingLink = "https://track.amazon.in/tracking/" + awbnumber + "?trackingId=" + awbnumber;
      } else if (agrecator === "Ekart") {
        trackingLink = "https://ekartlogistics.com/shipmenttrack/" + awbnumber;
      }

      var firebaseConfig = {
        apiKey: "AIzaSyD_l1BF58RX8kOhTSZw6eN2O1cxKNesk4k",
        authDomain: "hbm-tracking-page.firebaseapp.com",
        databaseURL: "https://hbm-tracking-page-default-rtdb.firebaseio.com/",
        projectId: "hbm-tracking-page",
        storageBucket: "hbm-tracking-page.appspot.com",
        messagingSenderId: "983280525533",
        appId: "1:983280525533:web:d2f99dfc1ba09788d4fb34",
      };
      // Initialize Firebase
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      } else {
        firebase.app(); // if already initialized, use that one
      }
      var database = await firebase.database();
      var ref = database.ref("hbmpagetracking").push();
      ref.set({
        phonenumber: phonenumber,
        date: date + "-" + orderMonth,
        tracking_id: trackingLink,
      }).then(() => {
        this.setState({isLoading: false});
        alert("Added successfully");
      }).catch(err => {
        this.setState({isLoading: false});
        alert("Oops an error occurred");
      });
    }
  };

  render() {
    return (
      <div className="App">
        <br />
        <div
          style={{
            display: this.state.isLoading ? "none" : "block",
          }}
        >
          <img src={Logo} alt="" width="100" />
          <br />
          <h2>Admin Page</h2>
          <br />
          <div className="form">
            <input
              type="number"
              className="form-control1"
              id="phonenumber"
              placeholder="Enter Customers Phone Number"
              aria-label="Enter Customers Phone Number"
              style={{
                width: "80%",
              }}
            />
            <br />
            <br />
            <select
              class="form-control1"
              id="agrecator"
              style={{
                width: "80%",
              }}
            >
              <option>Shypway</option>
              <option>Nimbus Post</option>
              <option>Delhivery(Direct)</option>
              <option>Shiprocket</option>
              <option>Amazon Shipping</option>
              <option>Ekart</option>
            </select>
            <br />
            <br />
            <br />
            <input
              type="text"
              className="form-control1"
              id="awbnumber"
              placeholder="Enter AWB number"
              aria-label="Enter AWB number"
              style={{
                width: "80%",
              }}
            />
          </div>
          <br />
          <button className="btn btn-success" onClick={this.addItem}>
            Add Order
          </button>
        </div>

        <center>
          <div
            class="spinner-border"
            role="status"
            style={{
              display: this.state.isLoading ? "block" : "none",
            }}
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </center>
      </div>
    );
  }
}

export default Admin;
